import waterImage from '../OrgImages/waterimage.webp';
import longUnderline from '../OrgImages/longunderline.svg';

export const OrgImpactTrackingShowcase = () => {
  return (
    <section className='relative h-full w-full overflow-hidden bg-gray-800'>
      <img
        src={waterImage}
        alt=''
        loading='lazy'
        className='absolute inset-0 h-full w-full object-cover'
      />

      <div className='absolute inset-0 bg-black/20' />

      <div className='absolute bottom-12 left-12'>
        <h1 className="m-0 text-display-2xl font-bold text-white tracking-[-1.44px]">
          Your <br />
          mission <br />
          matters
        </h1>
        <img src={longUnderline} alt='' className='mt-3 h-[10px] w-[278px]' />
      </div>
    </section>
  );
};

